import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  UpsertGorgiasIntegrationResponseDataSchema,
  UpsertGorgiasIntegrationSchema,
} from "schema"
import { z } from "zod"
import { gorgiasIntegrationQueryKey } from "../../lib/gorgias/gorgiasIntegrationQuery"

type Response = DataResponse<z.infer<typeof UpsertGorgiasIntegrationResponseDataSchema>>

export function useUpsertGorgiasIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertGorgiasIntegrationSchema>) => {
      const response = await axios.post<Response>(`/integrations/gorgias`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: gorgiasIntegrationQueryKey })
    },
  })
}
